// CSS declarations
import "@rainbow-me/rainbowkit/styles.css";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import * as React from "react";
import * as ReactDOM from "react-dom/client";
import "./index.css";
import { routeTree } from "./routeTree.gen";

const router = createRouter({ routeTree });
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);
